export default function auth({ store})
{
    if (! store.getters["auth/authenticated"])
    {
        return 'login';
    }

    return false;
}
